/* src/app/stocking/menus/menu/menu.component.css */
body {
  background-color: #f0f0f0;
}
.menu-preview-box {
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin-top: 10px;
  width: 300px;
  overflow-x: auto;
}
.product-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.input {
  padding: 10px;
  margin: 3px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100px;
  text-align: right;
}
.table-header-text {
  font-size: 24px;
  font-weight: bold;
}
.past-week {
  opacity: 0.6 !important;
}
.active-week {
  background-color: #3f51b5 !important;
  color: white !important;
}
.current-week {
  border: 2px solid #4caf50 !important;
  box-shadow: 0 0 8px rgba(76, 175, 80, 0.25);
}
.menu-is-locked {
  border: 2px solid #fcc168 !important;
  box-shadow: 0 0 8px rgba(252, 193, 104, 0.25);
}
.hollyday-text {
  color: red;
}
.hollyday-description {
  margin-top: 5px;
  color: red;
  font-size: small;
}
.hollyday-input {
  border: 1px solid red;
  color: red;
}
.mat-column-price {
  width: 30px;
  width: 100px;
}
.mat-column-description {
  width: 30px;
  width: 100px;
}
.mat-column-mandag {
  width: 30px;
  width: 100px;
}
.mat-column-tirsdag {
  width: 30px;
  width: 100px;
}
.mat-column-onsdag {
  width: 30px;
  width: 100px;
}
.mat-column-torsdag {
  width: 30px;
  width: 100px;
}
.mat-column-fredag {
  width: 30px;
  width: 100px;
}
.total-footer {
  text-align: center;
  font-weight: bold;
}
.sum-footer {
  padding-right: 30px;
  text-align: right;
  font-weight: bold;
}
.total-coumn {
  font-weight: bold;
  text-align: center;
  width: 100px;
}
.expansion-panel-header-text {
  font-size: 16px;
  font-weight: bold;
  color: #3f51b5;
}
.expansion-panel-header {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.expansion-panel-description {
  flex-grow: 1;
  text-align: right;
  margin-right: 75px;
  font-size: 16px;
  font-weight: bold;
}
.expansion-panel {
  margin: 20px;
}
.table-header {
  font-weight: bold;
  text-align: center !important;
}
.description-spacer {
  flex-grow: 1;
}
.category-total {
  width: 160px;
  font-weight: bold;
  text-align: center !important;
  font-size: 16px;
  font-weight: bold;
}
.new-text {
  font-size: 16px;
  font-weight: bold;
  color: #b53f43;
  padding-left: 10px;
}
::ng-deep .select-product-form-field .mat-mdc-form-field-subscript-wrapper,
.mat-mdc-form-field-bottom-align::before {
  height: 0px !important;
}
::ng-deep .select-product-form-field .mdc-line-ripple::before {
  border: none !important;
}
::ng-deep .select-product-form-field .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  width: 100%;
  background-color: white !important;
}
.vegan-icon {
  color: #4caf50 !important;
}
.form-field {
  width: 100%;
}
.input-auto-select {
  color: black;
}
input:disabled {
  color: black !important;
}
.example-tooltip-uppercase {
  text-transform: uppercase;
  font-size: 20pt;
}
.no-product {
  color: red;
  font-weight: bold;
}
.menu-is-draft {
  border: 2px solid #2196f3 !important;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.25);
}
.menu-is-empty {
  border: 2px solid #9e9e9e !important;
  box-shadow: 0 0 8px rgba(158, 158, 158, 0.25);
}
.menu-locked {
  background: #fafafa !important;
}
.menu-preview-box {
  display: none;
  position: absolute;
  top: 110%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 10px 16px;
  z-index: 10;
  min-width: 140px;
  border-radius: 6px;
  font-size: 13px;
}
[mat-raised-button]:hover + .menu-preview-box,
.menu-preview-box:hover {
  display: block;
}
.hide {
  opacity: 0.5;
}
/*# sourceMappingURL=menu.component.css.map */
